import { useRouter } from "next/router";
import { useEffect } from "react";
import { verifyUserToken } from "../apiFunctions/user";

const useVerifyUser = () => {
  const Router = useRouter();
  useEffect(() => {
    verifyUserToken()
      .then((res) => {
        //   console.log(res)
      })
      .catch((err) => {
        //   console.log(err)
        Router.push("/accounts/login");
      });
  });
};

export default useVerifyUser;
